export const numberWithoutSpaces = (value) => value?.replace(/\s+/g, "");
